//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniIcons from "@/components/uni-icon/uni-icon.vue"
import moment from 'dayjs'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    animation: {
      type: Boolean,
      default: false
    },
    //当前选中日期
    info: {
      type: [Object, String],
      default() {
        return {
          checkInDate: '',
          checkOutDate: '',
          startDate: '', // 门票 默认选中日期
          defaultOpenDate: '' // 默认打开日历月份
        }
      }
    },
    //日历数组
    range: {
      type: Array,
      default() {
        return []
      }
    },
    // 只有开始和结束时间
    rangeObj: {
      type: Object,
      default() {
        return {
          start: '',
          end: ''
        }
      }
    },
    //单选或多选
    pattern: {
      type: String,
      default: 'section'
    },
    //入住与离店的文案
    startText: {
      type: String,
      default: '入住'
    },
    endText: {
      type: String,
      default: '离店'
    }
  },
  data() {
    return {
      active: 0,
      needBlank: true,
      isCheckComplete: true,
      isRange: false,
      inside: {
        checkInDate: '',
        checkOutDate: ''
      },
      checkInDate: {
        date: {
          isCheckInDate: false
        }
      },
      checkOutDate: {},
      allMonthData: [],
      rangs: [],
      now: '',
    }
  },
  components: { uniIcons },
  computed: {
    //入住时间格式化
    currentStart() {
      return new Date(this.inside.checkInDate.replace(/-/gm, '/'))
    },
    //离店时间格式化
    currentEnd() {
      return new Date(this.inside.checkOutDate.replace(/-/gm, '/'))
    },
    //打开日历时滚动到当前月份
    defaultOpenDate() {
      let scrollIndex = 1
      let startMonth = this.info.defaultOpenDate ? this.info.defaultOpenDate.split('-')[1] : ''
      if (startMonth) {
        scrollIndex = (startMonth - this.allMonthData[0].month) + 1
        scrollIndex = scrollIndex <= 0 ? scrollIndex + 12 : scrollIndex
      }
      return 'calendar-content-item' + scrollIndex
    }
  },
  mounted() {
    if (this.pattern === 'section') { // 酒店的 入住-离店
      this.initDate()
      this.inside.checkInDate = this.info.checkInDate
      this.inside.checkOutDate = this.info.checkOutDate
    } else { // pattern === 'single'
      this.checkInDate.date.isCheckInDate = true
      this.inside.checkInDate = this.info.checkInDate
    }
  },
  watch: {
    rangeObj: {
      handler(val) {
        this.initDate()
      },
      deep: true
    },
    info: {
      handler(val) {
        if (val.checkInDate) {
          this.initDate()
        }
        if (val.startDate) {
          this.inside.checkInDate = this.info.startDate
        }
      },
      deep: true
    },
    range(val) {
      this.initDate()
    },
  },
  methods: {
    initDate() {
      this.now = new Date()
      this.initCalendar()
    },
    initCalendar() {
      // 需要显示节假日需要更新节假日信息，没有找到合适的节假日接口，这部分以后更新
      this.getAllMonthData(4) // saas 3.0.2 的新版日历，只要4个月信息
      let checkInMonth = this.info.checkInDate.split('-')[1]
      let checkInDate = this.info.checkInDate.split('-')[2]
      for (let month of this.allMonthData) {
        if ((month.month + '') === checkInMonth) {
          for (let date of month.date) {
            if ((date.showDate + '') === checkInDate) {
              date.isCheckInDate = true
              this.checkInDate = {
                month: month,
                date: date
              }
              break
            }
          }
        }
        if (this.pattern === 'section') {
          let checkOutMonth = this.info.checkOutDate.split('-')[1]
          let checkOutDate = this.info.checkOutDate.split('-')[2]
          if ((month.month + '') === checkOutMonth) {
            for (let date of month.date) {
              if ((date.showDate + '') === checkOutDate) {
                date.isCheckOutDate = true
                this.checkOutDate = {
                  month: month,
                  date: date
                }
                break
              }
            }
            break
          }
        }
      }
    },
    isLast(length, i) {
      let linage = parseInt(length / 7)
      if ((i + 1) / 7 > linage) {
        return true
      } else {
        return false
      }
    },
    isScope(month, day) {
      let date = new Date(month.year + '/' + month.month + '/' + day.dates)
      return this.currentStart < date && date < this.currentEnd && this.isCheckComplete
    },
    //关闭日历
    close() {
      this.$emit('on-close')
    },
    //选中日期
    determine() {
      this.$emit('on-determine', this.inside)
    },
    getMonthData(year, month) {
      let ret = []
      if (!year || !month) {
        let today = this.now
        year = today.getFullYear()
        month = today.getMonth() + 1
      }
      let firstDay = new Date(year, month - 1, 1)
      let firstWeekDay = firstDay.getDay()
      let firstDayWeekDay = firstDay.getDay()
      let preMonthDayCount = firstDayWeekDay - 1
      let lastDay = new Date(year, month, 0)
      let lastDate = lastDay.getDate()
      for (let i = 0; i < 38; i++) {
        let date = i - preMonthDayCount
        let showDate = date
        if (date <= 0) {
          showDate = ''
        } else if (date > lastDate) {
          continue
        }
        let isWeekend = false
        if ((showDate + firstWeekDay) % 7 === 0 || (showDate + firstWeekDay) % 7 === 1) {
          isWeekend = true
        }
        let isRestDay = false
        ret.push({
          showDate: showDate,
          dates: showDate,
          isWeekend: isWeekend,
          isCheckInDate: false,
          isCheckOutDate: false,
          isRestDay: isRestDay,
          isShow: false // 是否显示 库存和价格，对应样式 InRange
        })
      }
      return ret
    },
    createTemp(num) {
      let todayData = this.now
      let thisYear = todayData.getFullYear()
      let thisMonth = todayData.getMonth() + 1
      let temp = []
      for (let i = 0; i < num; i++) {
        if (thisMonth > 12) {
          thisYear += 1
          thisMonth = 1
        }
        temp[i] = {
          year: thisYear,
          month: thisMonth,
          date: this.getMonthData(thisYear, thisMonth)
        }
        thisMonth += 1
      }
      return temp
    },
    createRange(num) {
      let rangs = []
      if (this.rangeObj.start && this.rangeObj.end) {
        let currentDate = new Date(this.rangeObj.start.replace(/-/gm, '/'))
        let endDate = new Date(this.rangeObj.end.replace(/-/gm, '/'))
        while (currentDate.getTime() <= endDate.getTime()) {
          rangs.push(
            { date: moment(currentDate).format('YYYY-M-D'), type: 'ticket' } // 仅门票的日历不显示 库存等等
          )
          currentDate.setDate(currentDate.getDate() + 1)
        }
        this.isRange = true
      } else if (this.range.length > 0) {
        rangs = this.range
        this.isRange = true
      }
      this.rangs = rangs
    },
    getAllMonthData(num) {
      let temp = this.createTemp(num)
      this.createRange()
      if (this.isRange) {
        for (let i = 0; i < num; i++) {
          // 遍历每个月的日期
          temp[i].date.forEach(t => {
            t.isDisable = true
            let date = temp[i].year + '-' + temp[i].month + '-' + t.showDate
            this.rangs.forEach(tt => {
              if (tt.date === date) {
                t.isDisable = false
              }

              if (tt.date === date && tt.type !== 'ticket') {
                // 当前日期 属于 range里的日期，那么就需要展示 库存和价格
                // 仅门票的日历不显示 库存等等
                t.isShow = true
                t.stock = tt.stock
                t.saleSettlementPrice = tt.saleSettlementPrice
                t.childSettlementPrice = tt.childSettlementPrice
              }
            })
          })
        }
      } else {
        // 如果 Info.startDate 是有值的，且不是时间区间的，这个startDate指的有效开始日期 - 门票
        let startDate = this.info.startDate ? this.info.startDate.split('-')[2] : ''
        startDate && (startDate = parseInt(startDate))
        // 第一个月今天之前的日期不可点击
        for (let i of temp[0].date) {
          let today = this.now
          if ((i.showDate > today.getDate() || (i.showDate === today.getDate() && today.getHours() < 23))) {
            if (startDate) {
              if (i.showDate >= startDate) { // 日历上有效开始日期之后的时间可选
                break
              }
            } else {
              break
            }
          }
          i.isDisable = true
        }
      }
      this.allMonthData = temp
    },
    selectDate(month, day) {
      if (day.isDisable) {
        return
      }
      if (this.pattern === 'section') {
        if (this.checkInDate.date.isCheckInDate && this.checkOutDate.date.isCheckOutDate) {
          this.isCheckComplete = false
          this.checkInDate.date.isCheckInDate = false
          this.checkOutDate.date.isCheckOutDate = false
          day.isCheckInDate = true
          this.checkInDate = {
            date: day,
            month: month
          }
        } else if (this.checkInDate.date.isCheckInDate && !this.checkOutDate.date.isCheckOutDate) {
          // 判断点击是改变入住日期还是离店日期，年，年相等判断月，月相等判断日
          if (month.year > this.checkInDate.month.year || ((month.year === this.checkInDate.month.year) && (month.month > this.checkInDate.month.month)) || ((month.year === this.checkInDate.month.year) && (month.month === this.checkInDate.month.month) && day.showDate > this.checkInDate.date.showDate)) {
            this.isCheckComplete = false
            day.isCheckOutDate = true
            day.isCheckInDate = false
            this.checkOutDate = {
              date: day,
              month: month
            }
          } else {
            this.checkInDate.date.isCheckInDate = false
            day.isCheckInDate = true
            this.checkInDate = {
              date: day,
              month: month
            }
          }
        }
        if (this.checkInDate.date.isCheckInDate && this.checkOutDate.date.isCheckOutDate) {
          this.isCheckComplete = true
          this.inside.checkInDate = this.checkInDate.month.year + '-' + this.checkInDate.month.month + '-' + this.checkInDate.date.showDate
          this.inside.checkOutDate = this.checkOutDate.month.year + '-' + this.checkOutDate.month.month + '-' + this.checkOutDate.date.showDate
        }
      } else {
        this.isCheckComplete = false
        this.checkInDate.date.isCheckInDate = false
        day.isCheckInDate = true
        this.checkInDate = {
          date: day,
          month: month
        }
        this.inside.checkInDate = month.year + '-' + month.month + '-' + day.showDate
        this.$emit('activeDay', this.checkInDate)
      }
    },
    changeMonth(index) {
      this.active = index
    }
  }
}
